import React from "react";
import cx from "classnames";
import Link from "../../../components/Link";

const ZLaunchCoinInfoCard = ({ classNames, linkTo, icon, title, excerpt }) => {
  return (
    <div
      className={cx(
        "coin-info__card my-4 d-flex align-items-stretch",
        classNames
      )}
    >
      <Link
        to={linkTo}
        className="card shadow"
        style={{
          borderRadius: "0.75rem",
        }}
      >
        <div className="feature-image d-flex align-items-center justify-content-center">
          <img
            src={icon.publicURL}
            className="img-fluid"
            alt={title}
            width={93}
            height={93}
          />
        </div>

        <div
          className="card-body h-100 text-center"
          style={{
            color: "#152b43",
          }}
        >
          <h5 className="mt-1 mb-2">{title}</h5>
          <div
            className="mt-3 custom-text-truncate"
            dangerouslySetInnerHTML={{ __html: excerpt }}
          />
        </div>
      </Link>
    </div>
  );
};

export default ZLaunchCoinInfoCard;
